var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M8.168 20.179a8.626 8.626 0 0 0 9.75-1.737c3.371-3.382 3.378-8.872 0-12.26a8.626 8.626 0 0 0-12.218 0c-2.64 2.649-3.211 6.573-1.731 9.783.19.474.337.856.337 1.227 0 1.034-.995 2.315-.331 2.98.663.666 1.94-.332 2.965-.338.369 0 .755.154 1.228.345Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "m12.174 9.727.601 1.207c.06.12.174.201.306.219l1.345.195a.4.4 0 0 1 .226.684l-.975.939a.399.399 0 0 0-.116.355l.23 1.325a.406.406 0 0 1-.588.424L12 14.449a.412.412 0 0 0-.377 0l-1.204.626a.404.404 0 0 1-.588-.424l.23-1.325a.396.396 0 0 0-.116-.355l-.975-.938a.4.4 0 0 1 .224-.685l1.347-.194a.405.405 0 0 0 .306-.22l.602-1.207a.408.408 0 0 1 .725 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageStar);
export default __webpack_public_path__ + "static/media/message-star.dbc768c5ad0479d0594bad1e7e33436f.svg";
export { ForwardRef as ReactComponent };